import { legacy_createStore as _createStore, applyMiddleware, combineReducers, compose, Reducer } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { breadcrumbsReducer } from 'shared/store/breadcrumbs';
import { coworkingReducer } from 'shared/store/coworking';
import { customReducer } from 'shared/store/custom';
import { gaDataReducer } from 'shared/store/gaData';
import { subdomainReducer } from 'shared/store/subdomain';
import { userReducer } from 'shared/store/user';
import { IApplicationState, IContext, TReduxActions, TReduxStore } from 'shared/types/redux';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param debugEnabled
 * @param context
 */
export function createReduxStore(initialState: IApplicationState, debugEnabled: boolean, context: IContext) {
  const reducers = combineReducers({
    breadcrumbs: breadcrumbsReducer,
    coworking: coworkingReducer,
    custom: customReducer,
    gaData: gaDataReducer,
    subdomain: subdomainReducer,
    user: userReducer,
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(withExtraArgument(context)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): TReduxStore => _createStore(reducers, initialState, storeEnchancers) as TReduxStore;

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
